import Chart from 'react-apexcharts';
import { currentDatabaseSelector } from '@transport-insights/uikit';
import { useRecoilValue } from 'recoil';
import { useE3HistoricalData } from '@src/modules/performance/context/reports-api-hooks';
import { Text } from '@chakra-ui/react';
import { CHART_COLOURS } from '@src/modules/performance/shared/constants';
import ReportSection from './ReportSection';

const informationSource = {
  title: 'Trend in pavement peak roughness',
  content: [
    {
      title: '75th percentile Roughness',
      description:
  <Text fontSize="inherit" mb={2}>
    The trend in the 75th percentile road roughness for the sealed network per year for the last 5 years, reported in NAASRA counts/km. The VfM and Effectiveness calculations use the roughness figures for just the latest year. The average result for the peers is shown in black.
  </Text>,
      source:
  <Text fontSize="inherit" as="span">
    Sourced from AWM and calculated by Road Efficiency Group within Transport Insights.
  </Text>,
    },
  ],
};

function E3Quality() {
  const currentDatabase = useRecoilValue(currentDatabaseSelector);
  const { data: historicalData, isLoading: isLoadingHistoricalData } = useE3HistoricalData();
  const isRegionNationalOrStateHighways = currentDatabase?.id === 81 || currentDatabase?.id >= 1000;

  const sortedHistoricalData = historicalData?.sort((a, b) => a.year - b.year);
  const years = [...new Set(sortedHistoricalData?.map((x) => x.year).flat())];

  const historicalLockYear = sortedHistoricalData?.at(-1)?.lockYear;

  const chartData = [
    {
      name: currentDatabase?.name,
      type: 'line',
      data: historicalData?.map((x) => x.quality) || [],
      color: CHART_COLOURS.orange,
    },
    {
      name: 'Peer Group',
      type: 'line',
      data: historicalData?.map((x) => x.peerGroupQuality) || [],
      color: CHART_COLOURS.black,
    },
  ];

  const chartSeries = isRegionNationalOrStateHighways
    ? [...chartData.filter((x) => !x.name?.includes('Peer'))]
    : [...chartData];

  return (
    <ReportSection
      title="Trend in pavement peak roughness"
      lockYear={historicalLockYear}
      isLoading={isLoadingHistoricalData}
      informationSource={informationSource}
    >
      <Chart
        options={{
          title: {
            text: '75th percentile Roughness',
          },
          chart: {
            animations: {
              enabled: false,
            },
          },
          xaxis: {
            categories: years || [],
          },
          yaxis: [
            {
              min: 40,
              forceNiceScale: true,
              title: {
                text: 'NAASRA counts/km',
              },
              labels: {
                formatter(val) {
                  return `${val.toFixed(0)}`;
                },
                offsetX: 0,
              },
            },
          ],
          grid: {
            padding: {
              left: 20,
            },
          },
          dataLabels: {
            enabled: false,
          },
          legend: {
            show: true,
          },
        }}
        series={chartSeries}
        type="line"
        width="100%"
        height="240"
      />
    </ReportSection>
  );
}

export default E3Quality;
